import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const MatchesPage = () => {
  const [matches, setMatches] = useState([]);

  useEffect(() => {
    fetchMatches();
  }, []);

  const fetchMatches = async () => {
    try {
      const response = await axios.get(`${API}/matches`);
      setMatches(response.data);
    } catch (error) {
      console.error("Failed to fetch matches", error);
    }
  };

  const generateContract = async (matchId) => {
    try {
      await axios.post(`${API}/contracts/generate?match_id=${matchId}`);
      toast.success("¡Contrato generado!");
      fetchMatches();
    } catch (error) {
      toast.error("Error al generar contrato");
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F1DE] p-4">
      <div className="max-w-6xl mx-auto py-8">
        <h1 className="text-4xl font-bold text-primary mb-8" data-testid="matches-title">Tus Conexiones</h1>

        {matches.length === 0 ? (
          <Card className="rounded-3xl p-12 text-center">
            <CardTitle className="mb-4">Aún No Tienes Conexiones</CardTitle>
            <CardDescription>¡Comienza a explorar para encontrar tu hogar perfecto!</CardDescription>
          </Card>
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {matches.map((match) => (
              <Card key={match.id} className="rounded-2xl overflow-hidden" data-testid={`match-card-${match.id}`}>
                {match.property && (
                  <>
                    <img src={match.property.images[0]} alt={match.property.title} className="w-full h-48 object-cover" />
                    <CardHeader>
                      <div className="flex justify-between items-start">
                        <div>
                          <CardTitle>{match.property.title}</CardTitle>
                          <CardDescription>{match.property.municipality}</CardDescription>
                        </div>
                        <span className="bg-accent text-accent-foreground px-3 py-1 rounded-full text-sm font-bold">{match.match_score}%</span>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <p className="text-sm mb-4">Estado: {match.status}</p>
                      {match.status === "pending" && (
                        <Button onClick={() => generateContract(match.id)} className="w-full rounded-full bg-primary" data-testid={`generate-contract-${match.id}`}>
                          Generar Contrato
                        </Button>
                      )}
                    </CardContent>
                  </>
                )}
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MatchesPage;
